import React from 'react';
import AdminPanel from '../adminTools/AdminPanel';

/**
 * AdminControls component - Handles admin panel functionality
 * Separated from the main View3D component for better modularity
 */
const AdminControls = ({ 
    adminView,
    carEntity,
    lights,
    galleryEnabled,
    setGalleryEnabled,
    galleryEntity,
    shadowCasterEntity,
    original,
    bgConfig,
    hideAdminPanel,
    modelConfig,
    onGalleryFileChange,
    onCarFileChange
}) => {
    if (!adminView || !carEntity) return null;

    return (
        <AdminPanel 
            onGalleryFileChange={onGalleryFileChange}
            onCarFileChange={onCarFileChange}
            lights={lights}
            galleryEnabled={galleryEnabled}
            setGalleryEnabled={setGalleryEnabled}
            galleryEntity={galleryEntity}
            carEntity={carEntity}
            shadowCasterEntity={shadowCasterEntity}
            original={original} 
            bgConfig={bgConfig}
            hideAdminPanel={hideAdminPanel}
            modelConfig={modelConfig}
        />
    );
};

export default AdminControls; 